export function formatIndianCurrency(amount: number | string): string {
    const num = Number(amount);
    if (isNaN(num)) return "0";
    
    return new Intl.NumberFormat("en-IN").format(num);
  }